var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneySack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 556.379,
    height: 341.377,
    viewBox: "0 0 556.379 341.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.s{fill:#d5d5d5;}.a{opacity:0.997;}.b{fill:#ba9779;}.c{fill:#aa8b6f;}.d{fill:#7e6851;}.e{fill:#d7d8da;mix-blend-mode:multiply;isolation:isolate;}.f{fill:#a2a97b;}.g{fill:#c4c79f;}.h{fill:#8d9d4e;}.i{fill:#747b59;}.j{fill:#cdd197;}.k{fill:#98712c;}.l{fill:#ad8035;}.m{fill:#decbb5;}.n{fill:#b4a695;}.o{fill:#778440;}.p{fill:#829047;}.q{fill:#b8bc89;}.r{fill:#8c5b45;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1482.998 -896.813)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1482.998 896.813)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1630.71,1688.4l39.432-.541,42.134,19.124L1769.6,1676.4l-6.9-3.286,6.9-7.271h18.312l5.705-5.309-1.038-7.175-118.928-16.566-94.217-7.405-40.463,18.74-33.856,4.322L1492,1657.96l-9,5.238,46.537,37.4,46.728-19.514Z",
    transform: "translate(-1482.998 -1365.607)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.735 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.983)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1816.359,959.889s-34.316-2.532-34.442-2.912-4.179-11.523-3.8-11.649a30.54,30.54,0,0,1,3.419,0l.76-4.179-6.711-3.292s2.659-9.244,3.925-14.435,3.04-9.37,3.419-9.117,7.344,5.065,7.344,5.065,3.166-4.558,4.179-6.458a36.633,36.633,0,0,1,2.406-3.8s-3.546-7.218-3.166-7.218a93.263,93.263,0,0,1,27.478-5.065,115.284,115.284,0,0,1,25.705,2.279l-.633,5.825,18.234,6.2,2.279-4.938s4.558,2.532,13.169,7.091,8.23,6.584,8.23,6.584l-3.039,4.812s3.418,4.938,5.065,8.1.759,3.925.759,3.925l-3.925,3.166,2.658,5.065-34.062,12.536Z",
    transform: "translate(-1716.952 -896.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1792.113,1024.124l.76-4.179,34.822,16.208Z",
    transform: "translate(-1727.528 -975.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1846.135,977.571l-29.756-36.341,6.585-10.257,25.2,45.712Z",
    transform: "translate(-1743.056 -918.673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1964.781,968.626l2.533-49.257,18.233,6.2-15.955,43.053Z",
    transform: "translate(-1838.023 -911.247)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1990.8,1003.733c.253-.127,32.036-29.5,32.036-29.5l2.43,3.663-34.466,27.36Z",
    transform: "translate(-1854.676 -946.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1993.619,1032.257l32.923-15.828,1.288,2.454-33.7,14.26Z",
    transform: "translate(-1856.477 -973.359)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1882,1062.788s-2.7-1.013-2.533-1.942a9.692,9.692,0,0,1,1.857-2.785,5.618,5.618,0,0,1-1.865-1.182c-.415-.591-.348-4.964.514-5.413a44.871,44.871,0,0,1,22.766-6.406c12.86,0,20.066,1.617,20.515,2.455a27.685,27.685,0,0,1,.956,4.71s-1.52,1.193-1.267,1.277a5.858,5.858,0,0,1,1.267,1.857c.253.591-.676,5.487-.676,5.487l-25.833-.337Z",
    transform: "translate(-1783.265 -991.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1731.213,1078.813c-6.272.127-17.415,3.146-22.986,6.385s-29.63,22.865-45.585,36.541-26.339,35.075-36.595,54.7-14.436,50.9-13.042,77.495,9.244,41.026,8.99,41.787-7.851,13.8-6.837,14.562,4.812,4.938,5.7,4.558,18.361-3.166,19.247-3.039,36.594,8.61,74.582,11.016,83.952-3.039,105.1-8.737,26.971-9.117,26.971-9.117,11.269,2.152,16.335,1.646,13.422-2.026,13.548-3.166-3.039-5.7-4.432-7.471-5.192-5.952-5.571-6.2a11.1,11.1,0,0,0-1.266-.633s1.266-14.182-2.153-37.481-11.649-57.614-15.448-66.858-17.474-34.695-18.994-36.341-7.851-7.6-9.37-11.27-10.51-13.549-26.465-30.01-33.682-25.705-40.9-27.351S1731.213,1078.813,1731.213,1078.813Z",
    transform: "translate(-1612.744 -1013.203)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1877.328,1627.774a33.587,33.587,0,0,1-15.188,2.667c-.253-.084-.422-.253-.675-.337a2.775,2.775,0,0,1-1.689-.338c-.169-.084-.506.084-.676,0a25.931,25.931,0,0,1-4.052-2.026v-.338h-.338a.933.933,0,0,1,0-.675h.338c.844-1.52,2.195-2.279,3.461-3.292,2.448-2.111,4.9-3.968,7.344-6.163.422-.338.929-.338,1.351-.675.131-.139.264-.274.4-.407-.277-.131-.509-.231-.509-.231a140.727,140.727,0,0,0-.265-20.338l-.383.293c-2.954,2.195-5.993,3.461-9.117,5.4a55.6,55.6,0,0,1-6.669,3.461,33.51,33.51,0,0,0-3.714,1.435c-3.546,1.942-7.176,2.954-10.891,4.558-3.8,1.689-7.851,2.786-11.818,4.305-4.137,1.689-8.443,2.7-12.664,4.306-14.182,5.4-28.618,8.273-43.645,9.877-19.67,2.195-38.834,1.6-58.42-.506-24.482-2.617-47.951-7.936-69.9-19.67a114.627,114.627,0,0,1-10.131-6.078c-5.318-3.461-9.033-7.766-13.085-12.494l-.952-1.1c2.374,21.065,8.5,32.462,8.28,33.135a5.415,5.415,0,0,1-.255.522c.18.117.459.136.609.284a81.813,81.813,0,0,0,10.806,9.456c-.675,1.1-2.448,1.52-3.714,2.026-.253.168-.422.59-.675.59-2.279.507-4.136,1.6-6.416,2.11-.422.085-.929-.084-1.351.085a12.46,12.46,0,0,1-4.5.714c1.533,1.477,3.715,3.608,4.359,3.332.887-.38,18.361-3.166,19.247-3.039s36.594,8.61,74.582,11.016,83.952-3.039,105.1-8.737,26.971-9.117,26.971-9.117,11.269,2.152,16.335,1.646,13.422-2.026,13.548-3.166A6.034,6.034,0,0,0,1877.328,1627.774Z",
    transform: "translate(-1614.469 -1340.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1886.2,1090.457a123.7,123.7,0,0,1,20.767-4.052q2.262-.272,4.512-.446c-5.881-3.383-10.811-5.437-13.862-6.133-7.218-1.646-20.827-1.014-20.827-1.014-6.272.127-17.415,3.146-22.986,6.385a168.841,168.841,0,0,0-13.569,10.094,21.746,21.746,0,0,0,8.988,3.016C1862.225,1099.49,1873.875,1093.919,1886.2,1090.457Z",
    transform: "translate(-1758.323 -1013.203)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(184.094 286.223)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2016.386,1744.242l-.241,3.855.773.531-.833.432.127,4.441.853.537-1.315.4.353,4.7,37.037,14.963.646-17.348Z",
    transform: "translate(-2015.75 -1725.331)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M2171.2,1709.376l-17.45,10.1-9.115,4.632-24.4,10.33-.646,17.348,50.482-27.489.252-4.055-.3-.381.343-.342.276-1.192-.383-.306.424-.336.122-5.192-.422-.349.434-.5Z",
    transform: "translate(-2082.2 -1703.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2088.433,1708.181l17.45-10.1-30.237-6.357-58.13,18.911,37.4,12.511,24.4-10.33Z",
    transform: "translate(-2016.88 -1691.721)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.128)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2254.8,1717.07s-3.379,2.262-3.3,2.24,3.719-1.891,3.719-1.891Z",
    transform: "translate(-2166.615 -1717.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2254.645,1733.393s-3.3,1.81-3.19,1.816,3.573-1.51,3.573-1.51Z",
    transform: "translate(-2166.583 -1727.516)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2256.492,1738.5l-1.785,1.044,2.083-.663Z",
    transform: "translate(-2168.666 -1730.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2216.576,1739.66l-5.35,1.763s-.508.828-.346.811S2216.576,1739.66,2216.576,1739.66Z",
    transform: "translate(-2140.599 -1731.526)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2221.145,1749.471l-8.116,3.472-.072,1.151Z",
    transform: "translate(-2141.948 -1737.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2178.943,1769.934c-.137.045-5.771,2.919-5.771,2.919l5.734-2.33Z",
    transform: "translate(-2116.489 -1750.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2107.474,1787.633l9.386-2.344-9.42,2.88-7.524-2.2Z",
    transform: "translate(-2069.61 -1760.725)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2104.09,1801.648l5.848,2,5.436-1.973-5.412,1.354Z",
    transform: "translate(-2072.281 -1771.194)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2089.654,1804.556l11.032,4.073,6.58-2.976-6.654,2.22Z",
    transform: "translate(-2063.043 -1773.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2017.514,1756.424l5.656,2.394-6.488-1.963Z",
    transform: "translate(-2016.346 -1742.254)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2017.065,1771.449l6.09,2.744-7.405-2.342Z",
    transform: "translate(-2015.75 -1751.869)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M2085.279,1728.987a33.816,33.816,0,0,1-10.467-2.143,10.763,10.763,0,0,1-4.806-3.08c-.073-.125-.229-.216-.3-.341a4.413,4.413,0,0,1-.829-3.182l-20.114,6.8a2,2,0,0,1,.354,1.433c-.2.632-2.163,1.074-2.163,1.074l23.69,7.924a3.649,3.649,0,0,1,2.861-1.273,8.32,8.32,0,0,1,3.955,1.213l19.026-7.79,2.677-1.522q-.3.03-.611.066C2094.006,1728.644,2089.733,1729.3,2085.279,1728.987Z",
    transform: "translate(-2035.718 -1709.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M2167.113,1702.866c-.01-.484,1.036-1.1,1.036-1.1l-19.559-4.362-3.064.011-16.784,5.67c.77-.077,1.547-.115,2.334-.162.527-.048,1.1-.213,1.626-.221,1.132-.05,2.271-.221,3.4-.192a27.448,27.448,0,0,1,12.048,2.645,13.765,13.765,0,0,1,4.412,3.58c.075.085.105.249.182.294a9.25,9.25,0,0,1,1.543,2.87l2.352-1.338,11.358-6.346S2167.123,1703.351,2167.113,1702.866Z",
    transform: "translate(-2088.057 -1695.355)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M2184.566,1755.413l11.239-6.224,1.075-14.241-11.4,5.841Z",
    transform: "translate(-2123.781 -1719.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M2092.742,1712.31l33.974,11.306,11.4-5.841-32.478-9.662Z",
    transform: "translate(-2065.02 -1702.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M2102.527,1712.746l33.038,11.181,6.614-3.3-33.152-10.045Z",
    transform: "translate(-2071.281 -1703.793)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2193.082,1755.977l.432-14.2,6.614-3.3-1.094,14.322Z",
    transform: "translate(-2129.23 -1721.646)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 267.965)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M1529.167,1724.035l.935,1.6s8.281,5.811,11.42,9.417a39.831,39.831,0,0,1,4.742,6.612l39-19.167s.134-1.2-1.937-2.471a23.081,23.081,0,0,0-3.272-1.736l-38.935,2.738-30.921-11.82-2.938,1s2.538,1.269,6.077,3.273a49.36,49.36,0,0,1,5.81,3.806l4.742,1.937Z",
    transform: "translate(-1506.26 -1684.654)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1504.479,1667.662h1.8l37.333,23.308v1.2l1.231,19.286-16.524-12.407s-4.842-6.145-4.942-6.145-6.01-2.2-6.01-2.2l-11.621-8.248-.267-5.009.434-.468-.434-.2-.267-2.905.434-.467-.6-.267Z",
    transform: "translate(-1504.479 -1658.066)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1613.168,1703.744l39.436-18,.6,8.448-.7.551h.7v2.388l-.768.434.768.033.734,6.812-39.541,18.618Z",
    transform: "translate(-1574.032 -1669.639)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1543.615,1689.717l-16.85-9.55-22.286-14.96,5.007-1.381,64.46,6.16,9.105,1.733Z",
    transform: "translate(-1504.479 -1655.612)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.219 24.555)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1585.626,1743.707c0,.134,10.463,5.678,10.463,5.678l8.7-2.406-8.63,3.572Z",
    transform: "translate(-1585.626 -1731.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1606.213,1761.605l3.2,1.634,3.275-.817-3.239,1.374Z",
    transform: "translate(-1598.8 -1742.739)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1715.338,1709.209s-5.176,2.4-5.076,2.4,5.076-1.854,5.076-1.854h-.7Z",
    transform: "translate(-1665.384 -1709.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1714.217,1718.575l-4.508,2.438,5.276-2.4Z",
    transform: "translate(-1665.031 -1715.203)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1572.354,1691.018c.15.05,12.922,7.613,12.922,7.613a4.2,4.2,0,0,1,2.944-.7,4.545,4.545,0,0,1,2.516.868l29-12.936s-1.8-.1-2.1-.6a1.753,1.753,0,0,1-.15-1.152l-3.005-.251Z",
    transform: "translate(-1547.914 -1668.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1528.286,1664.6l-.1.965a51.826,51.826,0,0,0,7.663,3.042,39.473,39.473,0,0,0,10.418,1.152c.1-.05,39.068-17.229,39.068-17.229a50.32,50.32,0,0,1-13.474,1.453,68.427,68.427,0,0,1-11.77-1.453l-13.022-4.407s-5.309-1.754-7.863-3.506a8.753,8.753,0,0,1-3.256-3.606l-29.25,6.261a43.738,43.738,0,0,0,4.808,6.411,47.36,47.36,0,0,0,5.669,4.494Z",
    transform: "translate(-1505.899 -1641.013)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1536.863,1655.994c.067-.033.134,0,.2,0a42.134,42.134,0,0,1,19.223-2.963,34.948,34.948,0,0,1-8.224-4.3,3.907,3.907,0,0,1-1.9-.25,2.982,2.982,0,0,1-1.453-1.352l-20.1,4.858s1.114,1.152.963,1.953a2.039,2.039,0,0,1-.952,1.352c-.15.05,1.152,1.4,3.205,3.255a31.409,31.409,0,0,0,3.746,2.8c.341-.621.844-1.179,1.248-1.786.1-.133.267-.234.367-.368a9.459,9.459,0,0,1,2.3-2.3C1535.928,1656.562,1536.4,1656.328,1536.863,1655.994Z",
    transform: "translate(-1517.361 -1644.929)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1611.008,1677.157a58.858,58.858,0,0,1-8.843-.611,46.894,46.894,0,0,1-6.454-1.53,7.437,7.437,0,0,1-3,4.464c-1.1.8-2.1,1.5-3.272,2.271a17.49,17.49,0,0,1-6.445,2.137c-1.937.4-3.673.668-5.543,1.136a14.527,14.527,0,0,1-3.74.567c-.1,0-.234.1-.334.1a16.241,16.241,0,0,1-4.408,0c-.29-.055-.578-.1-.865-.147l.008.006a31.3,31.3,0,0,0,6.535,2.949,36.91,36.91,0,0,0,8.258,1.232,3.592,3.592,0,0,1,2.354-.865c1.552-.05,1.7.15,1.7.15l23.614-10.618a4.673,4.673,0,0,1-.074-.651C1610.507,1677.5,1611.008,1677.157,1611.008,1677.157Z",
    transform: "translate(-1545.197 -1662.772)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1546.343,1694.729l1.306,16.643-10.953-8.349-2.015-15.747v-.361Z",
    transform: "translate(-1523.806 -1670.388)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1534.681,1670l30-9.516,13.919,4.307v.451l-.352-.194-31.9,12.766Z",
    transform: "translate(-1523.806 -1653.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1544.408,1693.434l1.769,16.243,4.038,3.078-1.3-16.3Z",
    transform: "translate(-1530.03 -1674.558)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1544.408,1674.177l29.818-10.835,6.141,1.9-31.449,11.956Z",
    transform: "translate(-1530.03 -1655.302)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1924.226,1382.34c0-12.071-7.116-19.95-22.238-25.542-11.055-4.193-15.884-6.607-15.884-12.071,0-4.448,4.066-8.26,12.453-8.26a40.711,40.711,0,0,1,17.916,4.066l4.321-15.63a51.677,51.677,0,0,0-20.206-4.3v-8.782h-13.614v10.259c-12.954,3.511-20.439,12.851-20.439,24.3,0,12.453,9.276,20.332,23.508,25.287,10.293,3.685,14.359,6.735,14.359,12.071,0,5.591-4.7,9.277-13.6,9.277a49.408,49.408,0,0,1-21.475-5.337l-3.94,16.011c4.385,2.424,12.754,4.735,21.583,5.141v7.62h13.614v-8.57C1916.607,1404.672,1924.226,1394.253,1924.226,1382.34Z",
    transform: "translate(-1727.703 -1162.39)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1930.263 1129.273)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M2612.8,2128.855l25.317,10.59-.146,9.567-5.06,3.9,40.129,14.8,48.873-31.776-5.357-3.2-21.436.292-38.021-9.94-23.364-.821-15.7-.195Z",
    transform: "translate(-2612.804 -2104.352)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.851 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2770.663,2208.342v3.506l.731.438-.731.438.365,4.017.8.438-1.169.438.584,4.236,34.4,11.466-.394-15.753Z",
    transform: "translate(-2746.927 -2177.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M3037.506,2103.306l-15.24,10.138-8,4.71-21.526,10.736.394,15.753,44.186-27.753V2113.2l-.292-.329.292-.329.182-1.1-.365-.256.365-.329-.182-4.711-.4-.292.365-.475Z",
    transform: "translate(-2934.418 -2088.516)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2834.775,2091.473l15.24-10.138-27.753-4.053-51.6,20.413,34.59,9.225,21.526-10.736Z",
    transform: "translate(-2746.927 -2066.545)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.736 17.346)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3260.874,2119.718s-2.934,2.24-2.861,2.216,3.262-1.923,3.262-1.923Z",
    transform: "translate(-3182.106 -2119.718)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3262.67,2153.948s-2.885,1.826-2.788,1.826,3.153-1.57,3.153-1.57Z",
    transform: "translate(-3183.683 -2148.617)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3268.643,2164.734l-1.558,1.047,1.85-.718Z",
    transform: "translate(-3189.766 -2157.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3180.962,2171.454l-4.747,1.9s-.414.779-.268.755S3180.962,2171.454,3180.962,2171.454Z",
    transform: "translate(-3112.797 -2163.396)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3189.527,2190.836l-7.158,3.6v1.047Z",
    transform: "translate(-3118.245 -2179.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3106.154,2239.76c-.122.049-5.064,2.97-5.064,2.97l5.064-2.435Z",
    transform: "translate(-3049.625 -2221.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2955.791,2280.082l8.372-2.653-8.372,3.141-6.941-1.57Z",
    transform: "translate(-2921.097 -2252.865)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2959.479,2313.988l5.412,1.486,4.813-2.094-4.827,1.533Z",
    transform: "translate(-2930.07 -2283.216)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2929.625,2325.258l10.225,3.068,5.794-3.068-5.9,2.387Z",
    transform: "translate(-2904.866 -2293.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2771.394,2233.664l5.258,1.85-5.989-1.412Z",
    transform: "translate(-2770.663 -2215.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2771.832,2265.081l5.672,2.143-6.841-1.7Z",
    transform: "translate(-2770.663 -2242.44)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M2867.251,2153.29a30.691,30.691,0,0,1-9.6-1.351,9.765,9.765,0,0,1-4.528-2.52c-.073-.11-.219-.183-.292-.292a4.01,4.01,0,0,1-.931-2.836l-17.839,7.291a1.815,1.815,0,0,1,.4,1.279c-.146.584-1.9,1.1-1.9,1.1l21.91,5.843a3.31,3.31,0,0,1,2.52-1.315,7.56,7.56,0,0,1,3.652.876l16.8-8.131,2.339-1.53q-.274.045-.55.094C2875.139,2152.487,2871.3,2153.327,2867.251,2153.29Z",
    transform: "translate(-2799.183 -2124.807)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M3034.325,2092.442c-.037-.438.877-1.059.877-1.059l-17.967-2.848-2.775.183-14.886,6.084c.693-.113,1.4-.191,2.105-.278.475-.073.986-.256,1.46-.292,1.022-.109,2.046-.329,3.068-.365a24.918,24.918,0,0,1,11.065,1.716,12.5,12.5,0,0,1,4.2,2.995c.073.073.109.219.183.255a8.4,8.4,0,0,1,1.56,2.513l2.056-1.345,9.933-6.39S3034.362,2092.881,3034.325,2092.442Z",
    transform: "translate(-2940.184 -2076.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M3126.75,2181.862l9.831-6.273.171-12.963-10,5.936Z",
    transform: "translate(-3047.552 -2138.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M2925.033,2122.718l31.418,8.327,10-5.935-29.97-6.921Z",
    transform: "translate(-2877.254 -2101.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M2945.113,2126.731l30.563,8.266,5.806-3.36-30.6-7.23Z",
    transform: "translate(-2894.206 -2106.331)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M3141.748,2187.076l-.41-12.888,5.807-3.36-.182,13.037Z",
    transform: "translate(-3059.868 -2145.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M2971.958,2018.832h-.329l.219-.329-.219-3.031-.657-.329.511-.256-.036-2.483-.629-.219.374-.292-.374-3.542-28.767,13.037,1.323,14.356,28.954-13.474Z",
    transform: "translate(-2891.621 -2008.352)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2650.73,2021.06l17.967.329,28.767-13.036-23.874,2.081-13.4.949-13.584-.182-28.338,8.435s19.244,1.169,19.354,1.2S2650.73,2021.06,2650.73,2021.06Z",
    transform: "translate(-2618.266 -2008.352)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2650.73,2082.222s-13-.182-13.11-.219-19.354-1.205-19.354-1.205l.621,3.761.657.11-.585.474.183,1.388.548.073-.475.438.694,4.674,18,1.972,13.365.949,18.741,2.269-1.323-14.355Z",
    transform: "translate(-2618.266 -2069.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2623.305,2105.65l1.935.487-2.52-.012Z",
    transform: "translate(-2622.027 -2090.496)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2624.837,2118.076l2.958.621-3.432-.183Z",
    transform: "translate(-2623.413 -2100.986)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2713.455,2122.062c.146.1,5.259.195,5.259.195v.438Z",
    transform: "translate(-2698.629 -2104.351)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2717.051,2139.568h5.088v.536Z",
    transform: "translate(-2701.665 -2119.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2819.9,2124.407c.122.024,6.038.73,6.038.73l-6.038-.219Z",
    transform: "translate(-2788.493 -2106.331)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2873.98,2107.194c.073.024,10.978.541,10.978.541l4.6-1.928-4.669,1.214Z",
    transform: "translate(-2834.152 -2090.628)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2903.834,2139.63c.146.024,6.774.659,6.774.659l3.379-1.657-3.455.828Z",
    transform: "translate(-2859.356 -2118.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2916.025,2152.369c.122.049,5.021.591,5.021.591l2.574-1.2-2.629.6Z",
    transform: "translate(-2869.648 -2129.424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3090.835,2032.969l-6.626,3.311,7.256-3.092Z",
    transform: "translate(-3011.637 -2029.135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3105.9,2051.96l-4.029,2.033,4.687-1.7Z",
    transform: "translate(-3026.549 -2045.168)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3114.74,2075.641l-3.177,1.607,3.506-1.607Z",
    transform: "translate(-3034.73 -2065.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M2689.928,2039.627l1.015.038c-.139-.649-.3-1.295.117-1.791,2.775-3.359,7.413-3.4,11.284-4.747.913-.328,1.862-.474,2.812-.8.109-.037.255.037.365,0l.276-.07-8.09-.222a4.255,4.255,0,0,1-1.424.475,3.145,3.145,0,0,1-1.534-.219l-18.807,5.661s.876-.073,1.132.255-.219,1.023-.219,1.023Z",
    transform: "translate(-2666.958 -2028.343)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M2869.278,2020.549a1.192,1.192,0,0,1-.037-.475l-17.418,1.5-.837.044a3.152,3.152,0,0,1-.258,1.964c-1.022,1.972-3.4,2.52-5.3,3.287a2.462,2.462,0,0,0-.438.219c-.693.292-1.351.584-2.045.8a33.432,33.432,0,0,1-5.332,1.315c-.146.036-.329.036-.511.073a7.225,7.225,0,0,1-1.242.146,20.456,20.456,0,0,0-2.044.438l-.373.066.19.007,14.074.146a1.916,1.916,0,0,1,1.555-1.278,5,5,0,0,1,2.418.329l18.689-8.216S2869.352,2020.8,2869.278,2020.549Z",
    transform: "translate(-2799.932 -2018.248)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M2775.58,2021.569l-14.587.851-22.229,9.536,14.062.269Z",
    transform: "translate(-2719.996 -2019.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M2738.764,2088.254l.623,11.875,13.986.949-.547-12.555Z",
    transform: "translate(-2719.996 -2075.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2767.762,2100.869l-.147-12.062,4.906.094.062,12.3Z",
    transform: "translate(-2744.353 -2076.276)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M2772.52,2033.965l22.715-10.229-4.99.228-22.63,9.908Z",
    transform: "translate(-2744.353 -2021.339)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneySack);
export default __webpack_public_path__ + "static/media/moneySack.f758eb27513a55814d53961de568855d.svg";
export { ForwardRef as ReactComponent };